import { AuthForm } from '@/components/auth/auth-form';
import { urlLogin } from '@/urls';

function Login() {
  return (
    <div className="grid min-h-full lg:grid-cols-2">
      <div className="flex flex-col gap-4 p-6 md:p-10">
        <div className="flex justify-center gap-2 md:justify-start">
          <a href="https://playpadel.io" className="flex items-center gap-2 font-medium">
            <img src="/images/logo.png" alt="Logo" className="h-6 w-6 rounded-md" />
            playpadel.io
          </a>
        </div>
        <div className="flex flex-1 items-center justify-center">
          <AuthForm />
        </div>
      </div>
      <div className="relative hidden bg-muted lg:block">
        <img
          src="/images/padel-court.jpg"
          alt="Image"
          className="absolute inset-0 h-full w-full object-cover dark:brightness-[0.2] dark:grayscale"
        />
      </div>
    </div>
  );
}

export const route = {
  path: urlLogin(),
  element: <Login />,
};
